import { createContext, useMemo } from "react";

import { MainMenuContextType, MENU_SCREEN } from "../menu.types";

import { useMenuNavigation } from "../hooks/use-menu-navigation";
import { useMenuHeading } from "../hooks/use-menu-heading";
import { useApoints } from "../hooks/use-apoints";
import { useReferral } from "../hooks/useReferral";

interface MainMenuProviderProps {
  children: React.ReactNode;
  initialActiveScreen?: MENU_SCREEN;
}

export const MainMenuContext = createContext<MainMenuContextType | null>(null);

const MainMenuProvider = ({
  children,
  initialActiveScreen = MENU_SCREEN.Home,
}: MainMenuProviderProps) => {
  const { activeScreen, previousScreen, changeScreen, back } =
    useMenuNavigation(initialActiveScreen);

  const heading = useMenuHeading(activeScreen);

  const apoints = useApoints();

  const referral = useReferral({ initialReferral: { code: "352532" } });

  const value = useMemo(
    () => ({
      activeScreen,
      previousScreen,
      heading,
      apoints,
      referral,
      changeScreen,
      back,
    }),
    [activeScreen, previousScreen, heading, apoints, referral, changeScreen, back],
  );

  return (
    <MainMenuContext.Provider value={value}>
      {children}
    </MainMenuContext.Provider>
  );
};

export default MainMenuProvider;
